var React = require('react');

function ExpandMore (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M11.067 5.733L8 8.8 4.933 5.733 4 6.667 8 10.667 12 6.667z","key":0}),React.createElement("path",{"d":"M0 0H16V16H0z","key":1})]));
}

ExpandMore.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ExpandMore;

ExpandMore.default = ExpandMore;
